export const FETCH_DATA = `HOME_SCREEN/FETCH_DATA`;
export const FILE_DOWNLOAD = `FILE_DOWNLOAD`;

export const FETCH_DATA_REQUEST = `${FETCH_DATA}_REQUEST`;
export const FETCH_DATA_SUCCESS = `${FETCH_DATA}_SUCCESS`;
export const FETCH_DATA_FAILURE = `${FETCH_DATA}_FAILURE`;
export const FETCH_DATA_PROGRESS = `${FETCH_DATA}_PROGRESS`;

export const FILE_DOWNLOAD_REQUEST = `${FILE_DOWNLOAD}_REQUEST`;
export const FILE_DOWNLOAD_SUCCESS = `${FILE_DOWNLOAD}_SUCCESS`;
export const FILE_DOWNLOAD_FAILURE = `${FILE_DOWNLOAD}_FAILURE`;
